export default (source, target) => {
    Object.keys(source).forEach(key => target[key] = source[key]);
    
    return target;
}